;
(function (ng) {
  'use strict';

  angular.module('scrollToTop', []);
})(window.angular);